<template>
    <!-- 税目列表 -->
    <el-dialog
        title="选择税目"
        :visible.sync="showTaxDialog"
        width="80%"
        top="5vh"
        :before-close="handleCloseTaxTable"
        :close-on-click-modal="$root.dialogAutoClose"
        :close-on-press-escape="$root.dialogAutoClose"
    >
        <div style="overflow-y: hidden;margin-top: -30px">
            <el-form @submit.native.prevent :inline="true" :model="taxFormLine">
                <!--<el-form-item label="供方分类:">-->
                <!--<el-input size="mini" v-model="taxFormLine.categoryName" clearable></el-input>-->
                <!--</el-form-item>-->
                <el-form-item label="税目名称:">
                    <el-input
                        size="mini"
                        v-model="taxFormLine.name"
                        clearable
                        @keypress.13.native="getTaxList"
                    ></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button size="mini" type="primary" @click="getTaxList"
                        >查询</el-button
                    >
                </el-form-item>
            </el-form>
            <el-table
                :data="taxTableData"
                tooltip-effect="light"
                :cell-style="$root.tableCellStyle"
                @current-change="handleCurrentChange"
                highlight-current-row
                size="mini"
                height="360"
                ref="taxTable"
                class="headerTable"
                border
            >
                <el-table-column label="" width="50">
                    <template scope="scope">
                        <el-radio
                            :label="scope.row.id"
                            v-model="checkedRadio"
                            @change.native="
                                getRadioRow(scope.$index, scope.row)
                            "
                            >&nbsp;</el-radio
                        >
                    </template>
                </el-table-column>
                <el-table-column label="序号" width="50px">
                    <template slot-scope="scope">
                        <span>{{ scope.row.index }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="税目" min-width="150px">
                    <template slot-scope="scope">
                        <span>{{ scope.row.name }}</span>
                    </template>
                </el-table-column>

                <el-table-column label="税率（%）" min-width="150px">
                    <template slot-scope="scope">
                        <span>{{ scope.row.taxRate }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="起始日期" min-width="150px">
                    <template slot-scope="scope">
                        <span>{{ scope.row.taxTimeStart }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="截止日期" min-width="150px">
                    <template slot-scope="scope">
                        <span>{{ scope.row.taxTimeEnd }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作时间" min-width="150px">
                    <template slot-scope="scope">
                        <span>{{ scope.row.updateDate }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="说明" min-width="150px">
                    <template slot-scope="scope">
                        <span>{{ scope.row.remarks }}</span>
                    </template>
                </el-table-column>
            </el-table>
            <div style="text-align: right;padding: 20px 0">
                <el-pagination
                    background
                    @size-change="handleSizeChange"
                    @current-change="handlePageChange"
                    :current-page="1"
                    :page-sizes="$root.pageSizesArr"
                    :page-size="10"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="taxTotalCount"
                ></el-pagination>
            </div>
            <div slot="footer" class="dialog-footer" style="text-align: right;">
                <el-button @click="handleCloseTaxTable" size="mini"
                    >取 消</el-button
                >
                <el-button
                    type="primary"
                    @click="handleConfirmTaxTable"
                    size="mini"
                    >确 定</el-button
                >
            </div>
        </div>
    </el-dialog>
</template>

<script type="text/babel">
import Vue from "vue";
export default Vue.component("SelectTax", {
    data() {
        return {
            showTaxDialog: false,
            taxTableData: [],
            taxTotalCount: 0,
            checkedRadio: "",
            currentRow: "",
            taxFormLine: {
                pageNumber: 1,
                pageSize: 10,
                name: "",
                taxRate: ""
            }
        };
    },
    mounted() {
        this.getTaxList();
    },
    watch: {},
    methods: {
        show() {
            this.showTaxDialog = true;
            this.getTaxList();
        },
        /* 税目列表弹框 start */
        getTaxList() {
            //获取税目数据
            this.$root.postHttp(
                `/v1/itemTaxManage/searchList/${this.taxFormLine.pageNumber}/${this.taxFormLine.pageSize}`,
                this.taxFormLine,
                res => {
                    console.log(res);
                    this.taxTableData = res.data.data.records || [];
                    this.taxTableData.forEach((item, index) => {
                        item.index = index + 1;
                    });
                    this.taxTotalCount = res.data.data.total || 0;
                }
            );
        },
        handleCurrentChange(val) {
            console.log(val);
            this.currentRow = val;
            this.checkedRadio = val.id;
        },
        handlePageChange(pageNumber) {
            this.taxFormLine.pageNumber = pageNumber;
            this.getTaxList();
        },
        handleSizeChange(pageSize) {
            this.taxFormLine.pageSize = pageSize;
            this.getTaxList();
        },
        getRadioRow(index, row) {
            this.checkedRadio = row.id;
            this.$refs.taxTable.setCurrentRow(row);
        },
        handleCloseTaxTable() {
            this.showTaxDialog = false;
            this.checkedRadio = "";
            this.currentRow = "";
        },
        handleConfirmTaxTable() {
            this.showTaxDialog = false;
            this.checkedRadio = "";

            this.$emit("callback", this.currentRow);
        },
        clearChecked() {
            this.checkedRadio = "";
        }
        /* 供应商列表弹框 end */
    }
});
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/pages/common/selectTax.vue